module.exports = __webpack_public_path__ + "static/img/a025.ba31ee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a025.jpg
// module id = Z25Z
// module chunks = 0